import CallCenter from './call-center.service';

export default class EoxCallCenter extends CallCenter {}
